document.addEventListener("DOMContentLoaded", function() {

    var contactFormSubmitBtn = document.getElementById('contact-form_submit');
    var userdataCheckbox = document.getElementById('checkbox-userdata');
    var inputCheckboxUserdata = document.getElementById('input-checkbox-userdata');

    var telOrEmail = document.getElementById('tel-or-email');
    var invalidTelMessage = document.getElementById('not-valid-tel');
    var invalidEmailMessage = document.getElementById('not-valid-email');
    var invalidTelAndEmailMessage = document.getElementById('not-valid-tel-and-email');

    var telefonField = document.getElementById('contact-form_telefonnummer');
    var emailField = document.getElementById('contact-form_e-mail-adresse');

    // If there is a checkbox for userdata protection, create a toggle for the checkbox
    if (userdataCheckbox && inputCheckboxUserdata) {
        userdataCheckbox.addEventListener('click', function() {
            inputCheckboxUserdata.checked = !inputCheckboxUserdata.checked; 
            userdataCheckbox.classList.toggle('checked', inputCheckboxUserdata.checked); 
        });
    
        // If the checkbox is clicked, toggle the checked class on the checkbox
        inputCheckboxUserdata.addEventListener('click', function() {
            userdataCheckbox.classList.toggle('checked', inputCheckboxUserdata.checked); 
        });
    }

    function validateEmail(emailValue) {
        // Email needs to contain @ and .
        var emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailPattern.test(emailValue)) {
            return false;
        }
        return true;
    }

    function validateTel(telefonValue) {
        // Phone number can only contain numbers, space, -, (, ), ., + and /
        var phonePattern = /^[0-9()+\-\/.\s]*$/;
        
        if (!phonePattern.test(telefonValue)) {
            return false;
        }
        return true;
    }

    // Real-time validation
    function setupRealTimeValidation() {
        // for telefon
        if (telefonField) {
            telefonField.addEventListener('input', function() {
                if (this.value.trim() !== '') {
                    if (validateTel(this.value)) {
                        this.classList.remove('required');
                        invalidTelMessage.classList.remove('show');
                    } else {
                        this.classList.add('required');
                        invalidTelMessage.classList.add('show');
                    }
                } else {
                    this.classList.remove('required');
                    invalidTelMessage.classList.remove('show');
                }
            });
        }

        // for email
        if (emailField) {
            emailField.addEventListener('input', function() {
                if (this.value.trim() !== '') {
                    if (validateEmail(this.value)) {
                        this.classList.remove('required');
                        invalidEmailMessage.classList.remove('show');
                    } else {
                        this.classList.add('required');
                        invalidEmailMessage.classList.add('show');
                    }
                } else {
                    this.classList.remove('required');
                    invalidEmailMessage.classList.remove('show');
                }
            });
        }
    }

    function removeErrorMessages() {
        if (invalidEmailMessage) {
            invalidEmailMessage.classList.remove('show');
        }
        if (invalidTelMessage) {
            invalidTelMessage.classList.remove('show');
        }
        if (invalidTelAndEmailMessage) {
            invalidTelAndEmailMessage.classList.remove('show');
        }
        if (telOrEmail) {
            telOrEmail.lastElementChild.classList.remove('show');
        }
        if (emailField) {
            emailField.classList.remove('required');
        }
        if (telefonField) {
            telefonField.classList.remove('required');
        }
    }


    if (contactFormSubmitBtn) {
        contactFormSubmitBtn.addEventListener('click', function(event) {
            removeErrorMessages();
            var requiredFields = document.querySelectorAll('[required]');
            var checkboxContainer = document.getElementById('checkbox-container');

            // Check if the value of required fields are empty
            if (requiredFields) {
                requiredFields.forEach(function(field) {
                    if (field.value.trim() === '') {
                        event.preventDefault();
                        field.classList.add('required');
                        field.nextElementSibling.classList.add('show');
                    } else {
                        field.classList.remove('required');
                        field.nextElementSibling.classList.remove('show');
                    }
                })
            };

            // Check if the value of phone and email fields are empty if the telOrEmail field is created
            if (telOrEmail) {

                if (telefonField.value.trim() === '' && emailField.value.trim() === '') {
                    // If both fields are empty, show the error message
                    event.preventDefault();
                    telefonField.classList.add('required');
                    emailField.classList.add('required');
                    telOrEmail.lastElementChild.classList.add('show');
                }

                // Check if tel OR email are not empty, because if only one is not empty and valid, the rule passes
                if (telefonField.value.trim() !== '' || emailField.value.trim() !== '') {
                    if (telefonField.value.trim() !== '') {
                        if (validateTel(telefonField.value) === false) {
                            event.preventDefault();
                            telefonField.classList.add('required');
                            emailField.classList.remove('required');
                            invalidTelMessage.classList.add('show');
                        } else {
                            telefonField.classList.remove('required');
                            emailField.classList.remove('required');
                            invalidTelMessage.classList.remove('show');
                        }
                    }

                    if (emailField.value.trim() !== '') {
                        if (validateEmail(emailField.value) === false) {
                            event.preventDefault();
                            emailField.classList.add('required');
                            telefonField.classList.remove('required');
                            invalidEmailMessage.classList.add('show');
                        } else {
                            emailField.classList.remove('required');
                            telefonField.classList.remove('required');
                            invalidEmailMessage.classList.remove('show');
                        }
                    }
                } 

                // Check if tel AND email are not empty...
                if (emailField.value.trim() !== '' && telefonField.value.trim() !== '') {
                    removeErrorMessages();

                    // ...and if they are both invalid
                    if (validateEmail(emailField.value) === false && validateTel(telefonField.value) === false) {
                        event.preventDefault();
                        emailField.classList.add('required');
                        telefonField.classList.add('required');
                        invalidTelAndEmailMessage.classList.add('show');
                    } 
                    // ...and if only email is not valid
                    else if (validateEmail(emailField.value) === false && validateTel(telefonField.value) === true) {
                        event.preventDefault();
                        emailField.classList.add('required');
                        telefonField.classList.remove('required');
                        invalidEmailMessage.classList.add('show');
                    } 
                    // ...and if only tel is not valid
                    else if (validateEmail(emailField.value) === true && validateTel(telefonField.value) === false) {
                        event.preventDefault();
                        emailField.classList.remove('required');
                        telefonField.classList.add('required');
                        invalidTelMessage.classList.add('show');
                    } else {
                        // ...and if both are valid
                        emailField.classList.remove('required');
                        telefonField.classList.remove('required');
                    }
                }
            } else {

                // Validation for tel and email fields if the telOrEmail field is not created...
                // ... if Tel field exists and is not empty
                if (telefonField && telefonField.value.trim() !== '') {
                    if (validateTel(telefonField.value) === false) {
                        event.preventDefault();
                        telefonField.classList.add('required');
                        invalidTelMessage.classList.add('show');
                        console.log('cai aqui?');
                    } else {
                        telefonField.classList.remove('required');
                        invalidTelMessage.classList.remove('show');
                    }
                }

                // ... if Email field exists and is not empty
                if (emailField && emailField.value.trim() !== '') {
                    if (validateEmail(emailField.value) === false) {
                        event.preventDefault();
                        emailField.classList.add('required');
                        invalidEmailMessage.classList.add('show');
                    } else {
                        emailField.classList.remove('required');
                        invalidEmailMessage.classList.remove('show');
                    }
                }
            }

            // Check if the userdata checkbox is checked
            if (userdataCheckbox) {
                if (!userdataCheckbox.classList.contains('checked')) {
                    event.preventDefault();
                    userdataCheckbox.classList.add('required');
                    checkboxContainer.lastElementChild.classList.add('show');
                } else {
                    userdataCheckbox.classList.remove('required');
                    checkboxContainer.lastElementChild.classList.remove('show');
                }
            }
        });
    }
    setupRealTimeValidation();
});